import styled from 'styled-components';
import backgroundImage from './images/background-image.png';
import rightArrowIcon from './images/right-arrow-icon.png';

export const Container = styled.div`
  display: flex;
  position: relative;
  min-height: 100vh;
  width: 100%;
  background-color: white;
  background-image: url(${backgroundImage});
  background-size: cover;
  overflow-y: auto;
`;

export const LeftSection = styled.div`
  flex: 1.2;
  padding: 30px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  max-width: 650px;
`;

export const RightSection = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
`;

export const BrandLogo = styled.img`
  width: 200px;
  margin-bottom: 20px;
  flex-shrink: 0;
`;

export const Title = styled.h1`
  font-size: 2em;
  margin-bottom: 0.4em;
  line-height: 1.2;
`;

export const Subtitle = styled.p`
  font-size: 0.95em;
  margin-bottom: 1.5em;
  line-height: 1.5;
  color: #555;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 1em;
`;

export const Button = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  background-color: #451DC7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #35169A;
  }
`;

export const SsoButton = styled.button`
  padding: 10px 20px;
  font-size: 1em;
  background-color: #451DC7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: #35169A;
  }

  &::after {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    background-image: url(${rightArrowIcon});
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 20px;
  }
`;

export const RobotImage = styled.img`
  max-width: 70%;
  height: auto;
  position: center;
  bottom: 0;
  right: 0;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 5px;
  width: 100%;
  max-width: 420px;
`;

export const Input = styled.input`
  padding: 10px 12px;
  font-size: 0.95em;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #5D33E2;
    box-shadow: 0px 0px 0px 3px rgba(93, 51, 226, 0.1);
  }

  &:disabled {
    background-color: #F5F5F5;
    cursor: not-allowed;
  }
`;

export const LoginButton = styled.button`
  padding: 10px 20px;
  font-size: 0.95em;
  font-weight: 600;
  background-color: #5D33E2;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #4a26c0;
    box-shadow: 0px 4px 12px rgba(93, 51, 226, 0.3);
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background-color: #b0a3d9;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 15px 0;
  color: #757575;
  font-size: 13px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #E0E0E0;
  }

  &:not(:empty)::before {
    margin-right: 10px;
  }

  &:not(:empty)::after {
    margin-left: 10px;
  }
`;

export const MicrosoftButton = styled.button`
  width: 100%;
  padding: 10px;
  font-size: 0.95em;
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  background-color: white;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    border-color: #5D33E2;
    background-color: #F9F9F9;
  }

  &:disabled {
    background-color: #F5F5F5;
    color: #B0B0B0;
    cursor: not-allowed;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;
